/*
 * Hai thành phần không vẽ gì: ghi nhận lượt xem trang và xử lý mã giới thiệu
 * (?ref=) khi người học vào bằng đường dẫn của người giới thiệu.
 */
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { affiliatePost, api, behaviorSessionId, trackBehavior } from "@/lib/api"

export function BehaviorTracker() {
  const { pathname: path } = useLocation()
  useEffect(() => {
    if (path === "/auth/login") return
    api("/api/session")
      .then(({ user }) => {
        if (!user) return
        const key = `simba-behavior-last:${behaviorSessionId()}:${path}`
        if (Date.now() - Number(sessionStorage.getItem(key) || 0) < 2 * 60_000) return
        sessionStorage.setItem(key, String(Date.now()))
        const eventType = path.startsWith("/classes/") ? "class_open" : path.startsWith("/courses/") ? "course_open" : "page_view"
        trackBehavior(eventType, path).catch(() => {})
      })
      .catch(() => {})
  }, [path])
  return null
}

export function ReferralTracker() {
  useEffect(() => {
    const normalized = new URLSearchParams(location.search).get("ref")?.trim().toUpperCase()
    if (!normalized) return
    const trackedKey = "simba_referral_tracked"
    if (localStorage.getItem(trackedKey) !== normalized) {
      affiliatePost("/api/user/affiliate/track-visit", {
        referral_code: normalized,
        source_app: "simba",
        audience_type: "learner",
        landing_path: `${location.pathname}${location.search}`,
        user_agent: navigator.userAgent,
      })
        .then(() => localStorage.setItem(trackedKey, normalized))
        .catch(() => {})
    }
    localStorage.setItem("simba_pending_referral", normalized)
    api("/api/session")
      .then(({ user }) => {
        if (!user) return
        return affiliatePost("/api/user/affiliate/link-referral", {
          referral_code: normalized,
          source_app: "simba",
          audience_type: "learner",
        }).then(() => localStorage.removeItem("simba_pending_referral"))
      })
      .catch(() => {})
  }, [])
  return null
}
